import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { analyticsState } from 'state/analytics';
import { userSession } from 'state/session';
import { tenantConfig } from 'utils/tenant';
import { downloadBlob } from 'utils/ui/downloadImage';
import { handleDownloadError } from 'utils/ui/handleDownloadError';
import { useCapture3DSnapshot } from 'hooks/useCapture3DSnapshot';
import { DownloadMenuButton } from './DownloadMenuButton';

export default function Download3dSnapshotMenuItem() {
  const session = userSession().useState();
  tenantConfig().useState();
  const carName = session.carDisplayName || undefined;
  const capture3DSnapshot = useCapture3DSnapshot();

  if (!userSession().canDownload3dSnapshot) {
    return false;
  }

  const handleDownload = async () => {
    try {
      const blob = await capture3DSnapshot();
      const filename = carName ? `${carName} - snapshot.jpg` : 'snapshot.jpg';
      downloadBlob(blob, filename);
      analyticsState().setValues({ dealerToolUsed: 'downloadImage' });
    } catch {
      handleDownloadError('ERROR_3D_SNAPSHOT_CAPTURE', t`Failed to capture snapshot`);
    }
  };

  return (
    <DownloadMenuButton
      onClick={handleDownload}
      label={<Trans>Download current image</Trans>}
      testId="download-current-image"
    />
  );
}
